import React from 'react'
import { Elements } from 'react-stripe-elements'
import { StripeProvider } from 'react-stripe-elements'
import InjectedCheckoutForm from './CheckoutForm'

class MyStoreCheckout extends React.Component {
  state = {
    stripe: null
  }

  componentDidMount() {
    this.setState({
      stripe: window.Stripe(`${process.env.GATSBY_STRIPE_PUBLISHABLE_KEY}`)
    })
  }

  render() {
    return (
      <StripeProvider stripe={this.state.stripe}>
        <Elements>
          <InjectedCheckoutForm />
        </Elements>
      </StripeProvider>
    )
  }
}

export default MyStoreCheckout
